var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.1224 7.47229C15.5674 6.94444 15.5001 6.15584 14.9723 5.71091C14.4444 5.26598 13.6558 5.33319 13.2109 5.86105L7.84483 12.2272L5.95576 9.98605C5.51083 9.45819 4.72223 9.39098 4.19438 9.83591C3.66653 10.2808 3.59931 11.0694 4.04424 11.5973L6.88907 14.9723C7.12658 15.2541 7.47631 15.4167 7.84483 15.4167C8.21334 15.4167 8.56308 15.2541 8.80059 14.9723L15.1224 7.47229Z",
    fill: "#00DF80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.31572c6ec5f2002cc1a97bc446ca3e80.svg";
export { ForwardRef as ReactComponent };